import script from "./ProjectsIndexView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsIndexView.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsIndexView.vue?vue&type=style&index=0&id=cc6c72e0&lang=scss"

const __exports__ = script;

export default __exports__